module.exports = __webpack_public_path__ + "static/Denture 2 intraoral before-cb583fe3b0777971a1d142a2e3011f07.jpg";